import Home from '@/pages/Home';
import { CONTENT } from '@/content/locales';
import { LOCALES, SERVICE_KEYS, AE_SERVICE_PATHS, hubPath, servicePath, homeAlternates, ogAlternatesFor } from '@/lib/locales';
import { services as aeServices } from '@/components/services/servicesData';
import { UI } from '@/lib/localeUi';
import { SITE_URL, ORG_REF, breadcrumbLd, faqLd } from '@/lib/structuredData';

// Country hub: identical structure to the global home, with market-specific content.
export default function LocaleHub({ cc }) {
  const loc = LOCALES[cc];
  const { hub: c, services } = CONTENT[cc];
  const ui = UI[loc.lang];
  const path = hubPath(cc);
  const url = `${SITE_URL}${path}`;
  const crumbs = [{ label: ui.home, to: '/' }, { label: loc.label, to: path }];
  const iconFor = (k) => aeServices.find((s) => `/services/${s.slug}` === AE_SERVICE_PATHS[k])?.icon;

  return (
    <Home
      seo={{
        fullTitle: c.title, description: c.meta, path,
        lang: loc.hreflang, ogLocale: loc.og, ogAlternates: ogAlternatesFor(loc.og), alternates: homeAlternates(),
        structuredData: {
          '@context': 'https://schema.org',
          '@graph': [
            { '@type': 'WebPage', '@id': `${url}#webpage`, url, name: c.h1, description: c.meta, inLanguage: loc.hreflang, isPartOf: { '@id': `${SITE_URL}/#website` }, about: ORG_REF },
            breadcrumbLd(crumbs),
            faqLd(c.faqs)
          ]
        }
      }}
      hero={{
        eyebrow: loc.label,
        lead: c.heroLead || c.h1,
        accent: c.heroAccent,
        text: c.heroText || `${c.intro[0]} ${ui.serving} ${c.cities}.`
      }}
      services={{
        eyebrow: ui.services,
        title: ui.ourServices(loc.inCountry),
        items: SERVICE_KEYS.map((k) => ({ icon: iconFor(k), title: services[k].name, tag: ui.learnMore, to: servicePath(cc, k), ae: AE_SERVICE_PATHS[k] }))
      }}
      market={{
        eyebrow: loc.label,
        title: c.market.title,
        paras: c.market.paras,
        complianceTitle: ui.compliance(loc.inCountry),
        complianceParas: c.compliance.paras,
        bullets: c.compliance.bullets,
        sectorsTitle: c.sectors.title,
        sectors: c.sectors.items
      }}
      faqs={c.faqs}
    />
  );
}